import React, { useState, useEffect, useMemo, createContext } from "react";
import HeaderLayout from "Components/LoggedInLayout/HeaderLayout";
import { useLocation } from "react-router-dom";
import { observer } from "mobx-react";
import { LEARN_MORE_LINK } from "Static/constant";
import userDetail from "Stores/userDetail";
import TabNavigation from "Components/common/TabNavigation";
import { CALLS_TAB_NAVIGATION } from "Static/constant";
import CallsTabRouting from "Routes/CallsTabRouting";
import CallsFilter from "./CallsFilter";
import { upgradePopupState } from "Components/Paywall/UpgradePopup";
import { USER_SELECT_DROPDOWN_LIST } from "Static/constant";
import Utils from "Utils/utils";
import { openDialerCard } from "Global/commonUtils";
import { callsStore } from "Stores/Calls";
import taskStoreData from "Stores/taskData";
import copilotStore from "Stores/copilotStore";
import copilotDrawerStore from "Stores/copilotDrawerStore";
import { dialerLogsPopupState } from "Components/DailerService/DialerLogsAfterCallEndPopup";
import { useCopilotContext } from "Pages/Dashboard/Copilot/agent/copilotContext";
import usePageFindings from "Pages/Dashboard/Copilot/agent/usePageFindings";
import callsFindings from "./callsFindings";

const CallsFilterContext = createContext({});

const defaultState = {
  teamLoader: true,
  teamList: "",
  userFilterList: [...USER_SELECT_DROPDOWN_LIST]
};

export const CallsModule = observer(props => {
  const breadcrumbArr = [{ name: "Calls", link: "/calls" }];
  const {
    noOfContactsAddedInTeam,
    inFreePlan = false,
    dialerEnabled = false
  } = userDetail?.userFeatureFlag || {};

  let location = useLocation();
  let isOverview = location?.pathname?.indexOf("overview") !== -1;
  let pageType = isOverview ? "Overview Page" : "Analytics Page";

  const [data, setData] = useState({ ...defaultState });

  const getTeamList = async () => {
    const resData = await Utils.userTeamList();
    userDetail.setUserInfo({
      ...userDetail.userInfo,
      hasTeamMember: resData?.length ? resData : false
    });
    setData({ ...data, ...{ teamLoader: false, teamList: resData } });
  };

  const resetUserFilterOption = () => {
    const newArr = [...data.userFilterList];
    newArr.map(item => (item.checked = newArr.id === "you"));
    setData({ ...defaultState, userFilterList: newArr });
  };

  useEffect(() => {
    getTeamList();
    !Utils.isAdmin() && callsStore.loadCallLogAccess();
    return () => {
      resetUserFilterOption();
      upgradePopupState.setPopup(false);
    };
  }, []);

  const { overviewData = {} } = callsStore.inputValues || {};

  useCopilotContext("calls", () => ({
    viewState: {
      tab: isOverview ? "overview" : "analytics",
      filter: callsStore.filterPayload
    }
  }));

  const copilotFindings = useMemo(() => {
    const noOutcomeCount = (overviewData?.calls || []).filter(
      c => c?.outcome && !c?.disposition
    ).length;
    return callsFindings({
      calls: overviewData?.calls || [],
      totalCalls: overviewData?.totalCalls,
      taskRows: (taskStoreData.taskData?.tasks || []).map(r => ({
        ...r,
        task: { ...r?.task, taskDue: new Date(r?.task?.taskDue).getTime() || 0 }
      })),
      actions: {
        logOutcomes: () => {
          dialerLogsPopupState.setTotalContacts(noOutcomeCount);
          dialerLogsPopupState.setActionType("BULK_CONTACTS");
          dialerLogsPopupState.setShowLogCallPopup(true);
        },
        openOverdueTasks: () => {
          taskStoreData.setActiveDueTab("overdue");
          props.history.push("/tasks");
        },
        ask: query => {
          copilotStore.setPendingAutoSend(query);
          copilotDrawerStore.openFor("calls", "");
        },
        voicemailScript: () => {
          copilotStore.setPendingAutoSend("Write me a 20-second voicemail script for cold calls that earns a callback. Two versions.");
          copilotDrawerStore.openFor("calls", "");
        }
      }
    });
  }, [overviewData?.calls, overviewData?.totalCalls, taskStoreData.taskData]);
  usePageFindings(copilotFindings, "calls");

  return (
    <div className="callsSection">
      <HeaderLayout
        className="report"
        redirectUrl={LEARN_MORE_LINK.calls}
        breadcrumbArr={breadcrumbArr}
        {...props}
        btnType="calls"
        callbackAction={() => openDialerCard("calls")}
      />
      <div className={`callsContainer`}>
        <div className="callsBody">
          <div className="callsCard">
            <CallsFilterContext.Provider
              value={{
                ...data,
                isContactsAdded: noOfContactsAddedInTeam > 0,
                inFreePlan,
                isOverview,
                dialerEnabled,
                pageType
              }}
            >
              <div className="filterNaviagtionCard">
                <TabNavigation tabList={CALLS_TAB_NAVIGATION} />
                <CallsFilter />
              </div>
              <div className="callsTabRoutingWrapper">
                <CallsTabRouting />
              </div>
            </CallsFilterContext.Provider>
          </div>
        </div>
      </div>
    </div>
  );
});

export default CallsModule;
export { CallsFilterContext };
